import React, {useRef, useState} from 'react';
import {useDispatch} from "react-redux";
import IImageCropper from "../components/Admin/iImageCropper/IImageCropper";
import {ForceUpdate} from "./ForceUpdate";
import {useDebounceEffect} from "./useDebounceEffect";

export const useImageBrowser = (onDoneCallback = undefined,fixedSize = true) => {
    // upload new media
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    const Components = ({doneCallback = undefined}) => {
        const [imageToCrop, setImageToCrop] = useState(null);
        const [croppedResult, setCroppedResult] = useState({});
        const [cropperState, setCropperState] = useState({
            blobSrc: '',
            blobFile: null,
            orginalSrc: '',
            completedCrop: null,
            status: false
        });

        const handleFileInputChange = event => {
            const fileObj = event.target.files && event.target.files[0];
            if (!fileObj) {
                return;
            }

            // console.log('image to crop in hook')
            setImageToCrop(fileObj);
            event.target.value = null;
        };

        // update cropped result after crop file success
        useDebounceEffect(async () => {
            const resImg = {...cropperState};
            // console.log('cropped hook done')
            if (resImg?.blobSrc !== croppedResult?.blobSrc)
                setCroppedResult(resImg);
        }, 500, [cropperState])


        // call upload method if cropped result status is true
        useDebounceEffect(async () => {
            // console.log('result img changed')
            if (!croppedResult?.status) return;

            // let BlobFile = croppedResult.blobFile;
            // await updateAvatarImage(BlobFile);
            // let preview = document.getElementById("file-1-preview");
            // preview.src = croppedResult?.blobSrc;
            // console.log('upload new image', croppedResult?.blobSrc, doneCallback)
            if(doneCallback) {
                // console.log('run on done callback')
                doneCallback(croppedResult);
                dispatch(ForceUpdate)
            }
        }, 500, [croppedResult])

        return (
            <>
                <input
                    accept="image/*"
                    style={{display: 'none'}}
                    ref={fileInputRef}
                    type="file"
                    onChange={handleFileInputChange}
                />
                <IImageCropper aspectRatio={fixedSize ? 1 : 0} setCropperState={setCropperState} handleClose={() => setImageToCrop(null)}
                               src={imageToCrop}/>
            </>
        )

    }
    const imageBrowser = useRef({
        components: <Components doneCallback={onDoneCallback} />,
        browseForFile: () => fileInputRef?.current?.click(),
    })

    return [imageBrowser?.current]
};
